/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_status_in_progress = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In progress`)
};

const es_status_in_progress = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En curso`)
};

const de_status_in_progress = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In Bearbeitung`)
};

const nl_status_in_progress = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In behandeling`)
};

const fr_status_in_progress = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En cours`)
};

const it_status_in_progress = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In corso`)
};

const pt_br2_status_in_progress = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Em andamento`)
};

const pt_status_in_progress = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Em curso`)
};

const ja_status_in_progress = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`対応中`)
};

const zh_status_in_progress = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`处理中`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const status_in_progress = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.status_in_progress(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("status_in_progress", locale)
	if (locale === "en") return en_status_in_progress(inputs)
	if (locale === "es") return es_status_in_progress(inputs)
	if (locale === "de") return de_status_in_progress(inputs)
	if (locale === "nl") return nl_status_in_progress(inputs)
	if (locale === "fr") return fr_status_in_progress(inputs)
	if (locale === "it") return it_status_in_progress(inputs)
	if (locale === "pt-BR") return pt_br2_status_in_progress(inputs)
	if (locale === "pt") return pt_status_in_progress(inputs)
	if (locale === "ja") return ja_status_in_progress(inputs)
	return zh_status_in_progress(inputs)
};